export default ({ request }) => ({
  materialTemplateListApi(data = {}) {
    return request({
      url: '/master/material/input/template/list',
      method: 'post',
      data,
    })
  },
  materialTemplateSaveApi(data = {}) {
    return request({
      url: '/master/material/input/template/save',
      method: 'post',
      data,
    })
  },
  materialTemplateDetailApi(data = {}) {
    return request({
      url: '/master/material/input/template/detail',
      method: 'post',
      data,
    })
  },
  materialTemplateDelApi(data = {}) {
    return request({
      url: '/master/material/input/template/del',
      method: 'post',
      data,
    })
  },
  materialTemplateSelectApi(data = {}) {
    return request({
      url: '/master/material/input/template/select',
      method: 'post',
      data,
    })
  },
})
